import { WORKSPACE_ADMIN_ROLES } from "@common/constants";
import { useActiveWorkspaceRole } from "./useActiveWorkspaceRole";

export function useCanManageWorkspace() {
    const role = useActiveWorkspaceRole();
    return Boolean(role && WORKSPACE_ADMIN_ROLES.includes(role));
}
